
import zh from './zh.js'
import ja from './ja.js'
export const t = (str) => {
  const langObj = {
    zh,
    ja
  }
  const lang = localStorage.getItem('lang') ?? 'zh'
  return langObj[lang][str] ?? str
}